import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { ModalBody } from '@/shared/components/NotificationModal';
import { Button } from '@/shared/components/Button';
import { StyledModal, ModalHeader, ModalTitle } from '@/shared/components/Modal';
import Carousel from '@/shared/components/carousel/CarouselSingle';
import { Card, CardBody, CardSubhead } from '@/shared/components/Card';
import { colorYellow } from '@/utils/palette';

const BANNER_SEEN_KEY = 'onboarding_forms_banner_seen';

const AlertNotifications = () => {
  const customerOnboardingFormsCompleted = useSelector(
    (state) => state?.auth?.currentUser?.customerOnboardingFormsCompleted,
  );
  const isLoggedIn = useSelector((state) => state?.auth?.isLoggedIn);

  // Static banner data
  const staticBanners = [
    {
      bannerID: 'onboarding-forms',
      name: 'Complete Your Onboarding Forms',
      message: 'Please complete your onboarding forms to access all features of the platform.',
      status: 'Live',
    },
  ];

  const [modal, setModal] = useState(false);
  const [displayCloseButton, setDisplayCloseButton] = useState(false);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  // Clear banner seen status when user logs out
  useEffect(() => {
    if (!isLoggedIn) {
      localStorage.removeItem(BANNER_SEEN_KEY);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    const hasSeenBanner = localStorage.getItem(BANNER_SEEN_KEY);
    if (!hasSeenBanner && !customerOnboardingFormsCompleted) {
      setModal(true);
    }
  }, [customerOnboardingFormsCompleted]);

  const toggle = () => {
    setModal((prevState) => !prevState);
    localStorage.setItem(BANNER_SEEN_KEY, 'true');
  };

  const handleCarouselChange = (index) => {
    setCurrentSlideIndex(index);
    setDisplayCloseButton(index === staticBanners.length - 1);
  };

  // Don't render anything if onboarding forms are completed
  if (customerOnboardingFormsCompleted) {
    return null;
  }

  return (
    <div>
      {staticBanners.length > 0 ? (
        <NotificationModal
          show={modal}
          onHide={toggle}
          color='primary'
          backdrop='static'
          keyboard={false}
        >
          <ModalHeader className='mb-1'>
            <ModalTitleIcon className='lnr lnr-flag' />
            <ModalBody>
              <Carousel onSlideChange={handleCarouselChange}>
                {staticBanners.map((item, index) => (
                  <div
                    key={item.bannerID}
                    className={index === 0 ? 'first-slide' : ''}
                  >
                    <Card>
                      <ModalTitle
                        centered
                        style={{ marginTop: '20px' }}
                      >
                        {item.name}
                      </ModalTitle>
                      <CardBody>
                        <CardSubhead>{item.message}</CardSubhead>
                      </CardBody>
                      {currentSlideIndex === staticBanners.length - 1 && (
                        <div style={{ padding: '20px', textAlign: 'center' }}>
                          <Button
                            variant='primary'
                            onClick={toggle}
                          >
                            Acknowledge
                          </Button>
                        </div>
                      )}
                    </Card>
                  </div>
                ))}
              </Carousel>
            </ModalBody>
          </ModalHeader>
        </NotificationModal>
      ) : null}
    </div>
  );
};

export default AlertNotifications;

const NotificationModal = styled(StyledModal)`
  .modal-content {
    width: 500px;
  }
`;

const ModalTitleIcon = styled.span`
  width: 24px;
  height: 24px;
  font-size: 24px;
  color: ${colorYellow};
`;
